import React from 'react';
import { Route } from 'react-router-dom';
import SignIn from '../components/SignIn';
import SignUp from '../components/SignUp';
import { AUTH_PATHS } from './paths.ts';
import { getCurrentSubdomain, isRootHost } from '../utils/tenant';

interface AuthRoutesProps {
  onSignIn: (userData: unknown) => void;
  RedirectToAppPublic: React.ComponentType<{ path: string }>;
}

export function renderAuthRoutes({
  onSignIn,
  RedirectToAppPublic,
}: AuthRoutesProps): React.ReactNode {
  const currentHostname = typeof window !== 'undefined' ? window.location.hostname : '';
  const currentSubdomain =
    typeof window !== 'undefined' ? getCurrentSubdomain() : '';
  const onAppSubdomain = currentSubdomain === 'app';
  const onCoreHost = typeof window !== 'undefined' && isRootHost(currentHostname);
  const shouldRedirectToApp = !onAppSubdomain && !onCoreHost;

  return (
    <>
      <Route
        path={AUTH_PATHS.SIGNIN}
        element={
          shouldRedirectToApp ? (
            <RedirectToAppPublic path={AUTH_PATHS.SIGNIN} />
          ) : (
            <SignIn onSignIn={onSignIn} />
          )
        }
      />
      <Route
        path={AUTH_PATHS.SIGNUP}
        element={
          shouldRedirectToApp ? (
            <RedirectToAppPublic path={AUTH_PATHS.SIGNUP} />
          ) : (
            <SignUp onSignIn={onSignIn} />
          )
        }
      />
    </>
  );
}
